export function paging(pages, limit = 20) {
  // pages 可能不存在
  if (!pages) return [[]];
  //
  let index = 0;
  let pageArr = [];

  while (index < pages.length) {
    pageArr.push(pages.slice(index, (index += limit)));
  }
  return pageArr;
}
